<template>
  <v-app-bar app flat clipped-left dense>
    <v-app-bar-nav-icon
        @click="$emit('menuClick')"
        aria-label="Navigation menu"
    ></v-app-bar-nav-icon>
    <v-toolbar-title class="d-flex align-center text-body-1">
      <branding-logo/>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <div v-if="breakpoint !== 'xs'">
      <v-btn plain>
        <v-icon aria-hidden="false"> mdi-account</v-icon>
        <span>{{ username }}</span>
      </v-btn>
    </div>
    <div v-if="breakpoint !== 'xs'">
      <v-btn plain @click="logout">
        <v-icon aria-hidden="false"> mdi-logout</v-icon>
        <span>{{ $t('common.logOut') }}</span>
      </v-btn>
    </div>
    <v-menu v-if="breakpoint === 'xs'" left bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item :href="userUrl">
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ username }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('common.logOut') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { killTimer } from '@/utils/AuthenticationExceptionPoller';
import BrandingLogo from '@/components/chrome/BrandingLogo';

export default {
  name: 'AppBar',
  components: {
    BrandingLogo,
  },
  data: () => ({
    userUrl:
        process.env.VUE_APP_HTTP +
        process.env.VUE_APP_API_ADDRESS +
        '/currentuser/edit',
  }),
  computed: {
    username() {
      return this.$store.getters['userSessionStateStore/user']?.userName;
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  methods: {
    logout() {
      try {
        this.$store.dispatch('auth/logout');
        killTimer();
      } catch (error) {
        console.log(error); // Do we have a global handler somewhere?
      }
    },
  },
};
</script>
